import React, { useState } from 'react';
import MonteCarloChart from '../MonteCarloChart/MonteCarloChartContainer';
import { Box } from '../CommonComponents/OPL/Box/Box';
import { MarketScenarios } from '../FinancialPlanOPL/Goals/goals/Retirement/components/MarketScenarios/MarketScenarios';
import { MonteCarloTab } from '../FinancialPlanOPL/Goals/goals/Retirement/tabs/MonteCarlo/MonteCarlo.meta';
import { MonteCarloTabSection } from '../FinancialPlanOPL/Goals/goals/Retirement/tabs/MonteCarlo/components/MonteCarloTabSection/MonteCarloTabSection';

interface Props {
  clientId: string;
  fpId: string;
  isPrint?: boolean;
}

export const MonteCarlo = ({ clientId, fpId, isPrint }: Props) => {
  const [activeView, setActiveView] = useState(MonteCarloTab.SummaryOfTrials);

  if (isPrint) {
    return (
      <Box p="0" mb="24" border="1px solid" borderColor="neutral.200" borderRadius="xl">
        <MonteCarloChart clientId={clientId} fpId={fpId} isPdf={isPrint} />
      </Box>
    );
  }

  return (
    <section>
      <MonteCarloTabSection activeView={activeView} setActiveView={setActiveView} />

      {activeView === MonteCarloTab.SummaryOfTrials && (
        <Box p="0" mb="24" border="1px solid" borderColor="neutral.200" borderRadius="xl">
          <MonteCarloChart clientId={clientId} fpId={fpId} isPdf={isPrint} />
        </Box>
      )}

      {activeView === MonteCarloTab.MarketScenarios && (
        <Box px="16" pb="24">
          <MarketScenarios />
        </Box>
      )}
    </section>
  );
};
